import { Grid } from "@mui/material";
import React from "react";

function JamezzPaymentsTransactionFees(props) {
  return (
    <div style={{ paddingLeft: "20px" }}>
      {props.paymentSettings && props.paymentSettings.fees
        ? Object.keys(props.paymentSettings.fees).map((name) => {
            if (
              props.paymentSettings.fees[name].hideFromBackoffice == undefined ||
              !props.paymentSettings.fees[name].hideFromBackoffice
            ) {
              return (
                <Grid container spacing={1}>
                  <Grid md={2} xs={12}>
                    <b>{name}</b>
                  </Grid>
                  <Grid align={"right"} md={3} xs={12}>
                    {new Intl.NumberFormat("nl-NL", {
                      style: "currency",
                      currency: props.currency ? props.currency.toUpperCase() : "EUR",
                      currencyDisplay: "symbol",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(props.paymentSettings.fees[name].sell)}
                  </Grid>
                  <Grid align={"right"} md={3} xs={12}>
                    +{props.paymentSettings.fees[name].sell_var}%
                  </Grid>
                </Grid>
              );
            }
          })
        : null}
    </div>
  );
}

export default JamezzPaymentsTransactionFees;
